import {Injectable} from '@angular/core';
import {getCookieOptions} from '@q9elements/ui-kit/common';
import {CookieService} from 'ngx-cookie-service';

import {AUTH_TOKEN, CONNECTION_SID, REDIRECT} from '../models/auth';

@Injectable({providedIn: 'root'})
export class Q9maCookieService {
  constructor(private cookieService: CookieService) {}

  private get cookieOptions() {
    const {path, domain, secure, sameSite} = getCookieOptions();

    return [path, domain, secure, sameSite] as Array<string>;
  }

  public setToken(token: string, remember: boolean = false) {
    this.deleteToken();

    let date;

    if (remember) {
      date = new Date();

      date.setDate(date.getDate() + 7);
    }

    return this.cookieService.set(AUTH_TOKEN, token, date, ...this.cookieOptions);
  }

  public setUserLocale(locale: string) {
    this.cookieService.set('q9-lang', locale, void 0, ...this.cookieOptions);
  }

  public isTokenValid(): boolean {
    const authToken = this.cookieService.get(AUTH_TOKEN);

    return Boolean(authToken);
  }

  public deleteToken() {
    return this.cookieService.delete(AUTH_TOKEN, ...this.cookieOptions);
  }

  public getToken() {
    return this.cookieService.get(AUTH_TOKEN);
  }

  /**
   * Returns the decoded redirect cookie value without validating it;
   * callers must check it with RedirectService.allowed().
   */
  public getRedirect(): string | null {
    if (!this.cookieService.check(REDIRECT)) {
      return null;
    }

    try {
      return decodeURIComponent(this.cookieService.get(REDIRECT));
    } catch {
      return null;
    }
  }

  /** `redirect` is stored as passed (typically still percent-encoded) and decoded once on read. */
  public updateRedirect(redirect: string) {
    return this.cookieService.set(REDIRECT, redirect, void 0, ...this.cookieOptions);
  }

  public deleteRedirect() {
    return this.cookieService.delete(REDIRECT, ...this.cookieOptions);
  }

  public deleteConnectionSid() {
    return this.cookieService.delete(CONNECTION_SID, ...this.cookieOptions);
  }
}
